import { toast } from "react-toastify";

export const SuccessNotification = (message, title) => {
  toast.success(
    <div className="flex flex-col">
      {title && <div className="font-bold">{title}</div>}
      <div className="text-sm">{message}</div>
    </div>,
    {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    }
  );
};
export const msgSuccessNotification = (message, title) => {
  toast.success(
    <div className="flex flex-col">
      {title && <div className="font-bold">{title}</div>}
      <div className="text-sm">{message}</div>
    </div>,
    {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    }
  );
};
export const InfoNotification = (message, title) => {
  toast.info(
    <div className="flex flex-col">
      {title && <div className="font-bold">{title}</div>}
      <div className="text-sm">{message}</div>
    </div>,
    {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    }
  );
};
export const msgInfoNotification = (message, title) => {
  toast.info(
    <div className="flex flex-col">
      {title && <div className="font-bold">{title}</div>}
      <div className="text-sm">{message}</div>
    </div>,
    {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    }
  );
};
export const ErrorNotification = (message, title) => {
  toast.error(
    <div className="flex flex-col">
      {title && <div className="font-bold">{title}</div>}
      <div className="text-sm">{message}</div>
    </div>,
    {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    }
  );
};

export const msgErrorNotification = (message, title) => {
  toast.error(
    <div className="flex flex-col">
      {title && <div className="font-bold">{title}</div>}
      <div className="text-sm">{message}</div>
    </div>,
    {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    }
  );
};
